import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/tours/register/page.tsx");
